/// <reference path="../vite-env.d.ts" />

export function showIntercom() {
  window.Intercom?.('show');
}

export function trackIntercomEvent(event: string, metadata?: Record<string, unknown>) {
  window.Intercom?.('trackEvent', event, metadata);
}
